/* eslint-disable react-hooks/exhaustive-deps */

import { Grid, TableRow, TableCell } from "@material-ui/core";
import { TableDaftarInventoryControl } from "App/Component/layout/Wms/PerbekalanFarmasi/InventoryControl/DaftarInventoryControl/DaftarInventoryControl";
import { getByFilterInventory } from "App/Component/layout/Wms/PerbekalanFarmasi/InventoryControl/DaftarInventoryControl/helpers";
import { RESET_STATE_FORM_FILTER } from "App/Component/layout/Wms/PerbekalanFarmasi/InventoryControl/DaftarInventoryControl/helpers";
import {
  DatatablesFooterServerSide,
  Loading,
  TableAction,
  TableWrapper,
  SearchInput,
} from "App/Component/ui";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import {
  DEFAULT_BOX_SHADOW,
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  STYLE_DEFAULT_MASTER,
} from "App/constants";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import {
  defaultToastError,
  isNull,
  defaultToastSuccess,
} from "App/utils/helpers";
import React, { useState, useEffect } from "react";
import {
  ITEM_TYPE_BARANG,
  RESET_TAB_MODAL,
} from "pages/Penjualan/Master/Rikjang/constants";
import {
  deleteItemById,
  addItemById,
} from "pages/Penjualan/Master/Rikjang/api";
import { RikjangFormItem } from "pages/Penjualan/Master/Rikjang/form/RikjangFormItem";

function TabBarang({ formData, setFormData, paketID }) {
  const classes = STYLE_DEFAULT_MASTER();
  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);

  const [formBarang, setFormBarang] = useState(RESET_TAB_MODAL);
  const [showModal, setShowModal] = useState(false);
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []);

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit,
    formSearch = formFilter
  ) => {
    if (!isNull(formData.gudang_id)) {
      setLoading(true);
      const res = await getByFilterInventory(
        {
          gudang_id: formData.gudang_id,
          barang_name: formSearch.barang_name,
        },
        pages,
        limit
      );
      if (res.state) {
        setRows(res.data);
        setTotalData(res.meta.count);
        setLoading(false);
      } else {
        setRows([]);
        setLoading(false);
        setTotalData(0);
        defaultToastError(res.message);
      }
    } else {
      setTotalData(0);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  const handleChange = (text) => async (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });

    if (!isNull(e.target.value) && e.target.value.length > 2) {
      await setNewData(formFilter.pages, formFilter.limit, {
        barang_name: e.target.value,
        gudang_id: formData.gudang_id,
      });
    } else {
      await setNewData(formFilter.pages, formFilter.limit, {
        barang_name: "",
        gudang_id: formData.gudang_id,
      });
    }
  };

  const handleClickSelect = async (row) => {
    setFormBarang({
      id: "",
      item_type: ITEM_TYPE_BARANG,
      item_id: row.barang_id,
      name: row.namaBarang,
      qty: 1,
    });
    setShowModal(!showModal);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      const barang = formData.barang;
      const checkBarang = barang.filter(
        (e) => e.item_id === formBarang.item_id
      );
      if (checkBarang.length === 0) {
        if (formData.isUpdate) {
          const res = await addItemById(
            {
              paket_id: paketID,
              item_type: ITEM_TYPE_BARANG,
              item_id: formBarang.item_id,
              qty: formBarang.qty,
            },
            "paket"
          );
          if (res.state) {
            barang.push({
              id: res.data.id,
              paket_id: paketID,
              item_type: ITEM_TYPE_BARANG,
              item_id: formBarang.item_id,
              namaBarang: formBarang.name,
              qty: formBarang.qty,
            });

            setFormData({
              ...formData,
              barang,
            });
            defaultToastSuccess(res.message);
          } else {
            defaultToastError(res.message);
          }

          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          setShowModal(false);
        } else {
          barang.push({
            item_type: ITEM_TYPE_BARANG,
            item_id: formBarang.item_id,
            namaBarang: formBarang.name,
            qty: formBarang.qty,
          });

          setFormData({
            ...formData,
            barang,
          });

          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          setShowModal(false);
        }
      } else {
        defaultToastError("Barang sudah ada");
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setShowModal(false);
      }
    } catch (error) {}
  };

  const clickDelete = async (row) => {
    const barang = formData.barang;
    const checkBarang = barang.filter((e) => e.item_id !== row.item_id);
    setFormData({
      ...formData,
      barang: checkBarang,
    });
    if (formData.isUpdate) {
      const res = await deleteItemById(row.id, "paket");
      if (res.state) {
        defaultToastSuccess(res.message);
      } else {
        defaultToastError(res.message);
      }
    }
  };

  useEffect(() => {
    if (!isNull(formData.gudang_id)) {
      setNewData(formFilter.pages, formFilter.limit, {
        gudang_id: formData.gudang_id,
      });
    } else {
      setRows([]);
      setTotalData(0);
    }
  }, [formData.gudang_id]);

  return (
    <div>
      {showModal && (
        <RikjangFormItem
          setShowModal={() => setShowModal(false)}
          form={formBarang}
          setForm={setFormBarang}
          disabled={disabled}
          handleSubmit={handleSubmit}
        />
      )}
      <Grid container spacing={2}>
        <Grid item sm={6}>
          <div
            style={{
              boxShadow: DEFAULT_BOX_SHADOW,
              padding: "1rem",
            }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "1rem",
              }}>
              <div>
                <p className='fw-600 fs-14'>DAFTAR BARANG</p>
              </div>
              <div>
                <SearchInput withIcon={true} onchange={handleChange("nama")} />
              </div>
            </div>
            <Loading show={loading} />

            <TableDaftarInventoryControl
              rows={rows}
              classes={classes}
              isSelect={true}
              handleClickUpdate={handleClickSelect}
            />
            <DatatablesFooterServerSide
              totalData={totalData}
              pagination={pagination}
              handleChangeLimit={handleChangeLimit}
              onPrevious={onPrevious}
              onNext={onNext}
              currentPage={pagination.page}
              handleClickPageNumber={handleClickPageNumber}
            />
          </div>
        </Grid>

        <Grid item sm={6}>
          <TableItemTransfer rows={formData.barang} clickDelete={clickDelete} />
        </Grid>
      </Grid>
    </div>
  );
}

export const TableItemTransfer = ({
  rows,
  clickDelete,
  filter = "namaBarang",
}) => {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: filter,
    orderByRow: [filter],
  });

  return (
    <>
      <TableWrapper
        title='Item Transfer'
        setQ={setQ}
        withAddButton={false}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}>
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  width={"10%"}
                  align='center'>
                  {index + 1}
                </TableCell>

                <TableCell
                  width={"10%"}
                  component='th'
                  scope='row'
                  padding='none'>
                  <TableAction
                    clickDelete={() => clickDelete(row)}
                    isUpdate={false}
                  />
                </TableCell>
                <TableCell align='left' width={"10%"}>
                  {row?.item_id}
                </TableCell>
                <TableCell align='left'>{row[filter]}</TableCell>
                <TableCell align='left' width='5%'>
                  {row.qty}
                </TableCell>
              </TableRow>
            );
          })}
      </TableWrapper>
    </>
  );
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "item_id",
    disablePadding: false,
    label: "ID",
    align: "left",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "qty",
    disablePadding: false,
    label: "QTY",
    align: "left",
  },
];

export default TabBarang;
